import { mapMutations, mapGetters, mapActions } from "vuex";
import { email, maxLength, minLength, required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";

export default {
    name: "feedback-form",
    mixin: [validationMixin],
    data() {
        return {
            payload: {
                name: "",
                email: "",
                message: "",
                status: "Подяка",
            },
            validationErrors: {},
        };
    },
    validations: {
        payload: {
            name: {
                required,
                minLength: minLength(3),
                maxLength: maxLength(20),
            },
            email: {
                required,
                maxLength: maxLength(50),
                email,
            },
            message: {
                required,
                minLength: minLength(10),
                maxLength: maxLength(100),
            },
        },
    },
    components: {},
    computed: {
        ...mapGetters({
            loading: "contacts/loadingFeedback",
        }),
        emailErrors() {
            let error = [];
            if (!this.$v.payload.email.$dirty) {
                return error;
            }
            if (!this.$v.payload.email.maxLength) {
                error.push(this.$t("validationMax") + " 50");
            }
            if (!this.$v.payload.email.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.email.email) {
                error.push(this.$t("validationEmail"));
            }
            if (this.validationErrors.email) {
                this.validationErrors.email.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        nameErrors() {
            let error = [];
            if (!this.$v.payload.name.$dirty) {
                return error;
            }
            if (!this.$v.payload.name.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.name.minLength) {
                error.push(this.$t("validationMin") + " 3");
            }
            if (!this.$v.payload.name.maxLength) {
                error.push(this.$t("validationMax") + " 20");
            }
            if (this.validationErrors.name) {
                this.validationErrors.name.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        messageErrors() {
            let error = [];
            if (!this.$v.payload.message.$dirty) {
                return error;
            }
            if (!this.$v.payload.message.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.message.minLength) {
                error.push(this.$t("validationMin") + " 10");
            }
            if (!this.$v.payload.message.maxLength) {
                error.push(this.$t("validationMax") + " 100");
            }
            if (this.validationErrors.message) {
                this.validationErrors.message.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        disableButton() {
            if (this.payload.name === "" || this.payload.email === "" || this.payload.message === "") {
                return true;
            }
            return false;
        },
    },
    created() {},
    methods: {
        ...mapActions({
            feedback: `contacts/SEND_FEEDBACK`,
        }),
        ...mapMutations({}),
        isLetter(event) {
            var key = event.keyCode || event.which;
            key = String.fromCharCode(key);

            var regex = /^[A-Za-zА-Яа-яЁёЄєІіЇї \s]+$/;
            if (!regex.test(key)) {
                event.preventDefault();
                return false;
            }
        },
        changeFeedbackStatus(status) {
            this.payload.status = status;
        },
        resetForm() {
            this.$v.$reset();
            this.payload.email = "";
            this.payload.name = "";
            this.payload.message = "";
        },
        submit() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                let obj = {
                    name: this.payload.name,
                    email: this.payload.email,
                    message: this.payload.message,
                    type: this.payload.status === "Подяка" ? 1 : 0,
                };
                this.feedback(obj)
                    .then(() => {
                        this.resetForm();
                        this.$toasted.success(this.$t("successAddFeedback"));
                    })
                    .catch(error => {
                        if (error.response.status === 422) {
                            this.validationErrors = error.response.data.errors;
                        }
                    });
            }
        },
    },
    destroyed() {},
};
